import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function MensagemReducer(state = initialState.mensagem, action){
    switch(action.type) {
        case types.CONSULTAR_MENSAGEM_PROTOCOLO_SENHA:
            
            return action.mensagem;
        case types.ENVIAR_AUTENTICACAO_MENSAGEM_PROTOCOLO_SENHA:
            
            return action.mensagem;
            case types.CADASTRAR_MENSAGEM:
            
            return action.mensagem;
        case types.TRAMITAR_MENSAGEM:
            
            return action.mensagem;
        case types.VALIDAR_CODIGO:
           
            return action.mensagem;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/MensagemReducer.js
 **/